// extracted by mini-css-extract-plugin
export default {"page":"SupportUsPage_page__hc55p"};